var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3AlphabeticSorting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11v54h54V11H11zm25 50H15V15h21v46zm25 0H40V15h21v46zm-5.43-26.34H44.92v-2.19l6.77-8.1h-6.24V22h9.94v2.19l-6.77 8.1h7l-.05 2.37zm-7.71 15.62h4.73l1 2.82h2.88L51.7 40.47h-2.85L44.06 53.1h2.81l.99-2.82zm2.37-6.7l1.59 4.63h-3.23l1.64-4.63zm-26.16 7.81h7v2.33h-10.7v-2.19l6.77-8.1H20.9v-2.34h9.94v2.2l-6.77 8.1zm-.75-19.54H28l1 2.81h2.89L27.15 22h-2.84l-4.8 12.63h2.82l.99-2.78zm2.37-6.71l1.59 4.64H24l1.69-4.64z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_Alphabetic_sorting.69581319.svg";
export { SvgJ3AlphabeticSorting as ReactComponent };